import { trackPageView } from '@pm/analytics';
import { useEffect } from 'react';
import { useLocation } from 'react-router';

type AnalyticsPageTrackingProps = {
  enableGoogleAnalyticsTracking?: boolean;
};

export const AnalyticsPageTracking = ({
  enableGoogleAnalyticsTracking,
}: AnalyticsPageTrackingProps) => {
  const location = useLocation();

  useEffect(() => {
    if (enableGoogleAnalyticsTracking) {
      const url = new URL(window.location.href);
      url.pathname = location.pathname;

      //redact the 'email' query param. This is sanitizing PII data from query params.
      if (url.searchParams.has('email')) {
        url.searchParams.set('email', 'REDACTED');
      }
      const redactedTargetPath = url.pathname + url.search;
      trackPageView({
        type: 'google',
        location: redactedTargetPath,
        pathname: url.pathname,
      });
    } else {
      trackPageView({ type: 'segment' });
    }
  }, [enableGoogleAnalyticsTracking, location]);

  return null;
};
